import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Col xs={12}>
        <Field name='fecha'>
          {({ field }) => <Form.InputDate {...field} id='filtro-fecha-resumenBoletas' isInvalid={iTouched && iError} disabled={fIsSubmitting} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaFormGroup)
